import Vue from 'vue'
import SvgIcon from '@/components/tool/SvgIcon'// svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
const toast = require.context('./svg/toast', false, /\.svg$/)
const global = require.context('./svg/global', false, /\.svg$/)
const icon = require.context('./svg/icon', false, /\.svg$/)
requireAll(req)
requireAll(toast)
requireAll(global)
requireAll(icon)



// WEBPACK FOOTER //
// ./src/icons/index.js